import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "utils/functions";

const colorBoxVariants = cva(
  "inline-flex flex-shrink-0 items-center justify-center size-11 rounded-md border border-solid  text-2xl",
  {
    variants: {
      color: {
        purple: "border-purple-300 bg-purple-100 text-purple-700",
        emerald: "border-emerald-300 bg-emerald-100 text-emerald-700",
        cyan: "border-cyan-300 bg-cyan-100 text-cyan-700",
        indigo: "border-indigo-300 bg-indigo-100 text-indigo-700",
        yellow: "border-yellow-300 bg-yellow-100 text-yellow-700",
      },
      size: {
        large: "size-11",
        medium: "size-9",
        small: "size-7",
      },
      roundness: {
        full: "rounded-full",
      },
    },
  },
);
export interface ColorBoxProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "color" | "size">, VariantProps<typeof colorBoxVariants> {}

export function ColorBox({ className, color, size, roundness, ...props }: ColorBoxProps) {
  return <div className={cn(colorBoxVariants({ color, size, roundness }), className)} {...props} />;
}
